import { constructDate, DeconstructedDuration, IsoDuration } from '@softline/core';

export function parseDuration(input: string): IsoDuration | null {
  try {
    const duration = parseCustomFormat(input);
    return duration;
  } catch (message) {
    return null;
  }
}

function parseCustomFormat(input: string): IsoDuration | null {
  const match = /^(\d{1,2})(\d{2})?(\d{2})?$/.exec(input);
  if (match == null) return null;

  const hours = +match[1];
  const minutes = +(match[2] ?? 0);
  const seconds = +(match[3] ?? 0);

  const deconstructed: DeconstructedDuration = {
    _type: 'duration',
    years: 0,
    months: 0,
    days: 0,
    hours,
    minutes,
    seconds,
    milliseconds: 0,
  };
  return constructDate(deconstructed);
}
